/**
 * Dynamically import store elements.
 */
import Vue from "vue";
import Vuex from "vuex";
import createMutationsSharer from "vuex-shared-mutations";
import modules from "./store/";

Vue.use(Vuex);

export default new Vuex.Store({
    modules,
    strict: process.env.NODE_ENV !== "production",
    plugins: [
        createMutationsSharer({
            predicate: (mutation) => {
                const predicate = [
                    "Application/SET_MONETARY_ACTIVITY",
                    "AudiobooksDiscover/SET_COLLECTIONS",
                    "AudiobooksCategories/SET_CATEGORIES",
                    "User/SET_DATA",
                    "User/SET_TOKEN",
                    "User/CLEAN_UP_DATA",
                    "UserMembership/CLEAN_UP_DATA",
                    "UserLibrary/CLEAN_UP_DATA",
                    "UserWallet/CLEAN_UP_DATA",
                    "UserMembership/SET_HIBOOKS_MEMBERSHIP",
                    "UserMembership/SET_NONFICTION_MEMBERSHIP",
                    "UserLibrary/SET_USER_BOOKS",
                    "UserLibrary/SET_FOLLOWSHIP_BOOKS",
                    "UserWallet/SET_COINS",
                    "UserWallet/SET_PRODUCTS",
                    "UserWallet/SET_CARD_INFO"
                ];
                return predicate.indexOf(mutation.type) >= 0;
            }
        })
    ]
});
